export const apiUrls = {
  auth: {
    accessToken: "/sso-service/api/v1/auth/access/token",
    logout: "/sso-service/api/v1/auth/logout",
    refreshToken: "/sso-service/api/v1/auth/refresh/token",
  },
  user: {
    profile: "/sso-service/api/v1/user/profile",
  },
  sso: {
    getAuthorities: "/sso-service/api/v1/user/authority",
    getUsers: "/sso-service/api/v1/user/list",
    deleteUser: "/sso-service/api/v1/user/delete/",
    createUser: "/sso-service/api/v1/user/create",
    updateUser: "/sso-service/api/v1/user/update",
    getSpecificUser: "/sso-service/api/v1/user",
    getGroups: "/sso-service/api/v1/group/list",
    deleteGroup: '/sso-service/api/v1/group/delete/',
    createGroup: "/sso-service/api/v1/group/create",
    updateGroup: "/sso-service/api/v1/group/update",
    getRoles: "/sso-service/api/v1/role/list",
    deleteRole: "/sso-service/api/v1/role/delete/",
    createRole: "/sso-service/api/v1/role/create",
    updateRole: "/sso-service/api/v1/role/update",
    getDesignations: '/sso-service/api/v1/user/getUsernameListByLabel/',
    getNotifications: "/dms-service/api/ve1/dashboard/getNotifications",
    getNotificationCount: "/dms-service/api/ve1/dashboard/getNotificationCount",
    UPLOAD_CONFIG_DATA: `/reconciliation-service/api/ve1/store/uploadConfig`,
    GET_UPLOAD_CONFIG_MAPPING: `/reconciliation-service/api/ve1/store/listUploadConfig`,
    duploadEmployeeStoreMapping: '/dms-service/api/ve1/store/uploadEmployeeStoreMapping/file',
    downloadAllActiveUsers: '/dms-service/api/ve1/store/downloadAllActiveUsers'
  },
};
